import apiService from "../../../../service/Api";

export interface SalesRep {
  id: number;
  full_name: string;
  email: string;
  profile_picture_url?: string | null;
}

interface PaginatedResponse<T> {
  results?: T[];
}

const unwrap = <T>(data: T[] | PaginatedResponse<T>): T[] =>
  Array.isArray(data) ? data : data.results ?? [];

export const fetchSalesReps = async (): Promise<SalesRep[]> => {
  const res = await apiService.get<SalesRep[] | PaginatedResponse<SalesRep>>(
    `/api/bookings/booking/sales-reps/`,
  );
  return unwrap(res.data);
};

export const assignSalesRep = async (
  bookingId: number,
  salesRepId: number,
): Promise<SalesRep> => {
  const res = await apiService.patch<{ id: number; sales_rep: SalesRep }>(
    `/api/bookings/booking/${bookingId}/assign-sales-rep/`,
    { sales_rep_id: salesRepId },
  );
  return res.data.sales_rep;
};
